import React from 'react';
import { useParams } from 'react-router-dom';
import {
  Column,
  Row,
  Loader,
  Flex,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import PageSection from 'src/components/enterprise/layout/PageSection';
import { useEmployeeDetailsInfo } from 'src/components/enterprise/features/Employee/EmployeeDetailsPage/components/EmployeeDetailsWrapper/EmployeeDetailsInfo/hooks/useEmployeeDetailsInfo';
import { EmployeeDetailsInfo } from 'src/components/enterprise/features/Employee/EmployeeDetailsPage/components/EmployeeDetailsWrapper/EmployeeDetailsInfo/EmployeeDetailsInfo';
import { DeactivateEmployeeWrapper } from 'src/components/enterprise/features/Employee/EmployeeDetailsPage/components/EmployeeDetailsWrapper/DeactivateEmployeeWrapper/DeactivateEmployeeWrapper';
import { RouterButtonLink } from 'src/components/RouterLink/RouterButtonLink';

export const EmployeeDetailsWrapper: React.FC = () => {
  const { corpid: corpId, employeeId } = useParams<{
    corpid: string;
    employeeId: string;
  }>();

  const { isLoading, employeeInfo } = useEmployeeDetailsInfo({
    corpId,
    employeeId,
  });

  if (isLoading) {
    return (
      <PageSection>
        <Flex alignItems="center" justifyContent="center" minHeight="140px">
          <Loader size="md" />
        </Flex>
      </PageSection>
    );
  }

  return (
    <PageSection>
      <Row>
        <Column phone={9}>
          {employeeInfo && <EmployeeDetailsInfo employeeInfo={employeeInfo} />}
        </Column>
        <Column phone={3}>
          <Flex
            justifyContent="center"
            flexDirection="column"
            alignItems="center"
          >
            <Stack y="xxx-sm" width="100%">
              <RouterButtonLink
                href={`/corporate/enterprise/${corpId}/employees/${employeeId}`}
                buttonVariant="primary"
                buttonSize="medium"
                useBlockButton
              >
                <Flex alignItems="center" justifyContent="center" width="100%">
                  Edit
                </Flex>
              </RouterButtonLink>
            </Stack>
            <DeactivateEmployeeWrapper
              corpId={corpId}
              employeeId={employeeId}
            />
          </Flex>
        </Column>
      </Row>
    </PageSection>
  );
};
